import React, { useEffect, useCallback, useState } from "react";
import { Layout } from "antd";
import { useNavigate, Link } from "react-router-dom";

import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
import QuestionnairesApi from "../../common/Apis/QuestionnairesApi";

const UserProtective = () => {
    const navigate = useNavigate();
    const { Content } = Layout;
    const urlParams = new URLSearchParams(window.location.search);
    const userEmail = urlParams.get("email");

    const [UserAnswer, setUserAnswer] = React.useState(null);

    const getUserAnswer = useCallback(() => {
        let filterData = window.btoa(
            "componentCode=PROTECTIVE_CLOTHS&createdBy=" + userEmail
        );

        QuestionnairesApi.FilterQuestionsetNext(filterData, 0, 100)
            .then((response) => {
                const list = response?.payloadDto || [];
                // Take the most recent record for this user
                const latest = [...list].sort(
                    (a, b) => (b.createdDate || 0) - (a.createdDate || 0)
                )[0] || null;
                setUserAnswer(latest);
            })
            .catch((err) => {
                console.log("Error PC", err);
            });
    }, [userEmail]);

    const handleClick = () => {
        navigate(-1);
    };

    const [isLoading, setIsLoading] = useState(false);
    const PageLoading = useCallback(() => {
        setIsLoading(true);
        setTimeout(() => setIsLoading(false), 800);
    }, []);

    useEffect(() => {
        getUserAnswer();
        PageLoading();
    }, [getUserAnswer, PageLoading]);

    function formatDate(date) {
        if (!date) return "";
        const dateNew = parseInt(date, 10);
        const options = { day: "2-digit", month: "short", year: "numeric" };
        const formattedDate = new Date(dateNew).toLocaleDateString("en-US", options);
        const [month, day, year] = formattedDate.split(" ");
        const capitalizedMonth = month.toUpperCase();
        return `${day} ${capitalizedMonth} ${year}`;
    }

    return (
        <Layout style={{ minHeight: "100vh" }}>
            <Sidebar />
            <Layout>
                <TopHeader />
                {isLoading && (
                    <div className="spinner-overlay" id="spinnerOverlay">
                        <div className="spinner"></div>
                    </div>
                )}
                <Content
                    className="form-content nav-content"
                    style={{
                        margin: "14px 16px 0",
                        padding: "30px",
                        background: "white",
                    }}
                >
                    <div>
                        <div className="col-xl-12 col-lg-7 col-md-12 px-0 healthCondent">
                            {UserAnswer ? (
                                <>
                                    <h5>
                                        <b>Name</b> : {UserAnswer?.name} <br />
                                        <b>Email</b> : {UserAnswer?.createdBy} <br />
                                        <b>Role Name</b> : {UserAnswer?.roleName} <br />
                                        <b>Date</b> : {formatDate(UserAnswer?.createdDate)} <br />
                                    </h5>
                                    <br />
                                    <h4 className="py-3 text-center">
                                        <b>Guidelines</b>
                                    </h4>
                                    <h5 className="pt-2" style={{ whiteSpace: "pre-line" }}>
                                        {UserAnswer?.guideline}
                                    </h5>
                                </>
                            ) : (
                                <h5 className="text-center py-5">
                                    No protective cloths record found for this user.
                                </h5>
                            )}
                        </div>
                    </div>
                    <Link
                        type="primary"
                        className="btn btn-primary btn-back"
                        onClick={handleClick}
                    >
                        Back
                    </Link>
                </Content>
            </Layout>
        </Layout>
    );
};

export default UserProtective;